export { S as StarRating } from '../../chunks/component-D--mL6bn.js';
import 'react/jsx-runtime';
import 'clsx';
import 'react';
import '../../chunks/component-CAP0rlm-.js';
import '../../chunks/component-DvX7tL61.js';
import '../../chunks/style-inject.es-tgCJW-Cu.js';

const isRatingValue = (value) => (typeof value === 'number' && [
    0,
    0.5,
    1,
    1.5,
    2,
    2.5,
    3,
    3.5,
    4,
    4.5,
    5,
].includes(value));

export { isRatingValue };
//# sourceMappingURL=index.js.map
